<template>
  <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-static-top navbar-light navbar-border navbar-brand-center" style="background:#281564;border-bottom: 3px solid #bf9f62">
      <div class="navbar-wrapper">
        <div class="navbar-header">
          <ul class="nav navbar-nav flex-row">
            <li class="nav-item"><a href="#" class="navbar-brand"><img alt="stack admin logo" style="max-height:30px" src="assets/images/icon.png" class="brand-logo">
                <h2 class="brand-text" style="color:white">UG@70</h2></a></li>
          </ul>
        </div>
        <div class="navbar-container container center-layout">
          <div id="navbar-mobile" class="collapse navbar-collapse"> 
          </div>
        </div>
      </div>
    </nav>

</template>

<script>
export default {
  name: 'Top'
}
</script>
<style scoped>

</style>

